export default "__VITE_ASSET__0ac932ee__"